<script>
  import Domains from "./Tabs/Domains.svelte";
  import Settings from "./Tabs/Settings.svelte";
  import {M} from "../external";

  let tab = "domains";

  function switchTab(newTab) {
    tab = newTab;
  }
</script>

<div class="top-background-wrapper wide-top-background" style="padding-top:30px;">
  <div class="top-background" style="max-width:1200px;" />
</div>
<div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
  <div class="sections-wrapper members-wrapper horizontal-flex-table">
    <div class="section-bg members-wrapper products-wrapper crm-table-outer email-campaign-wrapper">
      <ul class="upper-navigation upper-navigation-full mb-15">
        <li>
          <a on:click|preventDefault={() => switchTab("domains")} class:active={tab === "domains"}> {M.DOMAINS_SENDER}</a>
        </li>
        <li>
          <a on:click|preventDefault={() => switchTab("companyInfo")} class:active={tab === "companyInfo"}>{M.BRAND_DETAILS}</a>
        </li>
        <li class="none">
          <a on:click|preventDefault={() => switchTab("senderAndSocial")} class:active={tab === "senderAndSocial"}>Sender & Social</a>
        </li>
      </ul>
      <div>
        {#if tab === "domains"}
          <Domains />
        {:else if tab === "companyInfo"}
          <Settings />
          <!-- -->
        {:else if tab === "senderAndSocial"}
          <!-- -->
        {/if}
      </div>
    </div>
  </div>
</div>
